// fix this
/* eslint-disable no-useless-escape */
/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
import Cookies from 'cookie-universal';
import UserService from '@/services/UserService';
import useQuery from '@/compositions/useQuery.js';
import useMutation from '@/compositions/useMutation';
import CountryUtils from '@/components/commons/CountryUtils.js';
import LocationService from '@/services/LocationService';
import handlers from './events-handlers.js';
// import Tracking from './Tracking.js';
import LocalStorage, { LocalStorageKeys } from './LocalStorage.js';

export function getSessionValue(key) {
  const sessionObject = getCookieObject('ARTICLE_SESSION');
  return sessionObject[key];
}

export function getCookieObject(name) {
  if (!name) {
    return {};
  }

  let cookieContent = Cookies().get(name, { parseJSON: false });

  if (!cookieContent) {
    return {};
  }

  if (/(\'|\")/.test(cookieContent.charAt(0))) {
    cookieContent = cookieContent.substring(1, cookieContent.length - 1);
  }

  const content = cookieContent.substring(cookieContent.indexOf('-') + 1);

  if (!content || content === 'null') {
    return false;
  }

  const object = {};
  content.split('&').forEach((cookie) => {
    const [key, value] = cookie.split('=');
    object[key] = decodeURIComponent(value);
  });

  return object;
}

export function getRequestValue(key) {
  const url = window.location.href;
  const keysValues = url.split(/[\?&]+/);
  for (let i = 0; i < keysValues.length; i++) {
    const keyValue = keysValues[i].split('=');
    if (keyValue[0] === key) {
      return keyValue[1];
    }
  }
  return null;
}

export function getSessionCountry() {
  return CountryUtils.getCountryByCurrencyId(LocationService.getCurrencyId());
}

export function trackEvent(category, action, label, value, extra) {
  if (typeof category !== 'undefined' && typeof action !== 'undefined') {
    handlers.track(category, action, label, value, extra);
  }
}

export function getCartQuantity() {
  const cartItems = UserService.getCart()?.cartItems;
  if (cartItems) {
    if (cartItems.length) {
      let quantity = 0;
      for (let i = 0; i < cartItems.length; i++) {
        quantity += cartItems[i].quantity;
      }
      return quantity;
    }
  }
  return 0;
}

export function getFavoritesQuantity() {
  const favoritesData = LocalStorage.get(LocalStorageKeys.FAVORITES);

  if (favoritesData) {
    const data = JSON.parse(favoritesData);
    return Object.keys(data).length;
  }
  return 0;
}

export function isUser() {
  return isLoggedIn() || isUnverifiedUser();
}

export function isLoggedIn() {
  return UserService.isVerified();
}

export function isUnverifiedUser() {
  return UserService.isRegistered() && !UserService.isVerified();
}

export function checkLoggedIn() {
  if (!isLoggedIn()) {
    return;
  }

  const notLoggedInDom = document.querySelector('.account-link .not-logged-in');
  const loggedInDom = document.querySelector('.account-link .logged-in');
  if (notLoggedInDom && loggedInDom) {
    notLoggedInDom.classList.add('hidden');
    loggedInDom.classList.remove('hidden');
  }

  const accountMobileLinkContainer = document.querySelector('.account-mobile-link');
  if (accountMobileLinkContainer) {
    accountMobileLinkContainer.innerHTML = `<a href="/account"><p class="text">My Account</p></a>`;
  }
}

export const importScript = (url, attributes) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.addEventListener('load', () => {
      resolve();
    });

    script.addEventListener('error', () => {
      reject(new Error(`Import script (${url}) returned an error while loading.`));
    });

    script.src = url;
    script.async = true;
    script.type = 'text/javascript';

    if (attributes) {
      Object.keys(attributes, (attribute) => {
        script[attribute] = attributes[attribute];
      });
    }

    const body = document.getElementsByTagName('body')[0];
    if (body) {
      body.insertBefore(script, body.firstChild);
    } else {
      reject(new Error(`Import script (${url}) failed. Could not insert into the document body.`));
    }

    return script;
  });

export const validateEmail = (email) => {
  if (!email) {
    return false;
  }
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
};

export function isTouch() {
  return typeof window !== 'undefined' && 'ontouchstart' in document.documentElement;
}

export function getNewNavigationTestCondition() {
  if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'uat') {
    return true;
  }
  if (process.env.NODE_ENV === 'test') {
    return false;
  }

  const experiment = LocalStorage.get(LocalStorageKeys.NEW_NAVIGATION);

  if (experiment) {
    try {
      const { enabled } = JSON.parse(experiment);
      return enabled;
    } catch (error) {
      // Tracking.sentryCaptureError(error);
    }
  }

  const enabled = !!Math.floor(Math.random() * 2);

  LocalStorage.set(LocalStorageKeys.NEW_NAVIGATION, JSON.stringify({ enabled }));

  // Tracking.track('NEW_NAV_ENABLED', { enabled });

  return enabled;
}

export function browseRoomPageTestCondition() {
  return true;
}

export function getSimpleABTestingCondition(testName) {
  const testsJson = LocalStorage.get(LocalStorageKeys.AB_TESTS);
  let tests;
  if (testsJson) {
    tests = JSON.parse(testsJson);
    if (tests && typeof tests[testName] === 'boolean') {
      return tests[testName];
    }
  } else {
    tests = {};
  }

  if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'uat' || process.env.NODE_ENV === 'test') {
    tests[testName] = true;
  } else {
    tests[testName] = !!Math.floor(Math.random() * 2);
  }
  // Tracking.track(testName, { enabled: tests[testName] });
  LocalStorage.set(LocalStorageKeys.AB_TESTS, JSON.stringify(tests));
  return tests[testName];
}

// min and max inclusive
function getRandomNum(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// 0 = control
// 1 = limited image tags && productListModal
// 2 = no image tags && productListModal
export function getImageTaggingTestVariant() {
  return 1;
}

export function executeQuery(query, variables, options) {
  return new Promise((resolve, reject) => {
    const { onResult, onError } = useQuery(query, variables, options);

    onResult((data) => {
      resolve(data);
    });

    onError((error) => {
      reject(error);
    });
  });
}

export function executeMutation(mutation, variables, options, errorPolicy = 'none') {
  return new Promise((resolve, reject) => {
    const { mutate, onDone, onError } = useMutation(mutation);
    mutate(variables, options);

    onDone(({ data }) => {
      resolve({success: true, ...data});
    });

    if (errorPolicy === 'validation') {
      onError((error) => {
        const realErrors = error.networkError?.result?.errors;
        const errors = {};
        if (
          realErrors?.every((e) => {
            if (e.code === 'ValidationError') {  
              if (!errors[e.field]) {
                errors[e.field] = [];
              }
              errors[e.field].push(e.message);
              return true;
            }
          })
        ) {
          resolve({
            success: false,
            errors,
          });
        }
        reject(error);
      });
    } else {
      onError((error) => {
        reject(error);
      }); 
    }
  });
}

export function scrollTop() {
  window &&
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
}

/**
 * In an effort to move away from lodash, here we are defining a
 * replacement for lodash's debounce function.
 */
export function debounce(func, wait) {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

export function buildUrl(baseUrl, queryString) {
  if (!baseUrl || typeof baseUrl !== 'string') return '';
  if (typeof queryString !== 'object') return baseUrl;
  const formatVal = (val) => {
    if (typeof val === 'object') {
      return JSON.stringify(val);
    }
    return val;
  };
  let query;
  if (Array.isArray(queryString)) {
    query = queryString.map((qs) => `${encodeURIComponent(qs.key)}=${encodeURIComponent(formatVal(qs.val))}`).join('&');
  } else {
    query = Object.keys(queryString)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(formatVal(queryString[key]))}`)
      .join('&');
  }

  return baseUrl + (baseUrl.indexOf('?') > -1 ? '&' : '?') + query;
}

export function naivePluralize(text) {
  if (text) {
    const VOWELS = ['a', 'e', 'i', 'o', 'u'];
    const lastChar = text.charAt(text.length - 1);
    const secondLastChar = text.charAt(text.length - 2);

    switch (lastChar) {
      case 's':
      case 'ss':
      case 'sh':
      case 'ch':
      case 'x':
      case 'z':
        return `${text}es`;
      case 'y':
        if (VOWELS.includes(secondLastChar.toLowerCase())) {
          return `${text}s`;
        }
        return `${text.slice(0, text.length - 1)}ies`;
      default:
        return `${text}s`;
    }
  }

  return text;
}
